import * as React from 'react';
import CFilterOrderView from '../layouts/CFilterOrderView';
import { TatData } from 'src/reducers/fileUpload';
import { PreviewOrderData, RowDataManufactur } from 'src/reducers/manufactur';
import { RedesignReasons } from 'src/reducers/completeorderfile';
import { UserDetail } from 'src/reducers/user';
import { GetFileData } from 'src/reducers/rxForm';

export interface CFilterOrderComponentProps {
    onComponentDidMount: () => void;
    onComponentWillMount: () => void;
    mfilteredOrderData: RowDataManufactur[];
    isDownloading: boolean;
    redesignReasons: RedesignReasons[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onDownloadClick: (orderno: string, fileName: string) => void;
    onBulkDownload: () => void;
    onBulkDownloadStl: () => void;
    fromDate: (fromdate: string) => void;
    toDate: (todate: string) => void;
    dateFilter: () => void;
    dateReset: () => void;

    orderDataTat: TatData[];
    approvalRequired: (array: Array<object>) => void;
    redesignRequest: (columns: Object) => void;

    userDetails: UserDetail;

    caseFilter: (fcaseno: string, tcaseno: string, startDate: Date | null, endDate: Date | null, status: string) => void;
    caseFilterCust: (fcaseno: string, tcaseno: string) => void;

    downloadFile: (filepath: string, filename: string, status: string) => void;

    supportPage: (order: string) => void;

    getPreviewData: (orderno: string) => void;
    resetPreviewData: () => void;
    previewOrderData: PreviewOrderData;
    msgAtt: (msgAttachment: string) => void;
    goStlViewer: (data: GetFileData[]) => void;
    openVideoPlayerURL: (fullPath: string[], fpath: string) => void;
}

class CFilterOrderComponent extends React.Component<CFilterOrderComponentProps> {
    render() {
        return (
            <CFilterOrderView
                mfilteredOrderData={this.props.mfilteredOrderData}
                isDownloading={this.props.isDownloading}
                redesignReasons={this.props.redesignReasons}
                reload={this.props.reload}
                onRowClick={this.props.onRowClick}
                onDownloadClick={this.props.onDownloadClick}
                downloadFile={this.props.downloadFile}
                onBulkDownload={this.props.onBulkDownload}
                onBulkDownloadStl={this.props.onBulkDownloadStl}
                fromDate={this.props.fromDate}
                toDate={this.props.toDate}
                dateFilter={this.props.dateFilter}
                dateReset={this.props.dateReset}
                orderDataTat={this.props.orderDataTat}
                approvalRequired={this.props.approvalRequired}
                redesignRequest={this.props.redesignRequest}
                caseFilter={this.props.caseFilter}
                caseFilterCust={this.props.caseFilterCust}
                userDetails={this.props.userDetails}
                supportPage={this.props.supportPage}
                getPreviewData={this.props.getPreviewData}
                resetPreviewData={this.props.resetPreviewData}
                previewOrderData={this.props.previewOrderData}
                msgAtt={this.props.msgAtt}
                goStlViewer={this.props.goStlViewer}
                openVideoPlayerURL={this.props.openVideoPlayerURL}
            />
        );
    }
    componentDidMount() {
        // const url: string = window.location.href;
        this.props.onComponentDidMount();
    }
    componentWillMount() {
        // const url: string = window.location.href;
        this.props.onComponentWillMount();
    }
}

export default CFilterOrderComponent;



// WEBPACK FOOTER //
// ./src/components/CFilterOrder/CFilterOrderComponent.tsx